export const Districts = {
  Punjab: {
    MAJHA: {
      AMRITSAR: "Amritsar",
      GURDASPUR: "Gurdaspur",
      PATHANKOT: "Pathankot",
      TARN_TARAN: "Tarn Taran",
    },
    MALWA: {
      LUDHIANA: "Ludhiana",
      PATIALA: "Patiala",
      BATHINDA: "Bathinda",
      FEROZEPUR: "Ferozepur",
      MOGA: "Moga",
      SANGRUR: "Sangrur",
      MUKTSAR: "Sri Muktsar Sahib",
      FARIDKOT: "Faridkot",
      MANSA: "Mansa",
      BARNALA: "Barnala",
      FATEHGARH_SAHIB: "Fatehgarh Sahib",
      RUPNAGAR: "Rupnagar",
      SAS_NAGAR: "S.A.S Nagar (Mohali)",
    },
    DOABA: {
      JALANDHAR: "Jalandhar",
      HOSHIARPUR: "Hoshiarpur",
      KAPURTHALA: "Kapurthala",
      SBS_NAGAR: "Shahid Bhagat Singh Nagar (Nawanshahr)",
    },
    PUADH: {
      FATEHGARH_SAHIB: "Fatehgarh Sahib",
      PATIALA: "Patiala",
      SAS_NAGAR: "S.A.S Nagar (Mohali)",
      RUPNAGAR: "Rupnagar",
    },
  },
  Haryana: {
    "AMBALA DIVISION": {
      AMBALA: "Ambala",
      PANCHKULA: "Panchkula",
      YAMUNANAGAR: "Yamunanagar",
    },
    "ROHTAK DIVISION": {
      ROHTAK: "Rohtak",
      JHAJJAR: "Jhajjar",
      SONIPAT: "Sonipat",
    },
    "GURGAON DIVISION": {
      GURGAON: "Gurgaon",
      FARIDABAD: "Faridabad",
      NUH: "Nuh (Mewat)",
      REWARI: "Rewari",
      PALWAL: "Palwal",
    },
    "HISAR DIVISION": {
      HISAR: "Hisar",
      BHIWANI: "Bhiwani",
      FATEHABAD: "Fatehabad",
      JIND: "Jind",
      SIRSA: "Sirsa",
    },
  },
  Rajasthan: {
    AJMER: {
      AJMER: "Ajmer",
      BHILWARA: "Bhilwara",
      NAGAUR: "Nagaur",
      TONK: "Tonk",
    },
    BHARATPUR: {
      BHARATPUR: "Bharatpur",
      DHOLPUR: "Dholpur",
      KARAULI: "Karauli",
      SAWAI_MADHOPUR: "Sawai Madhopur",
    },
    BIKANER: {
      BIKANER: "Bikaner",
      CHURU: "Churu",
      HANUMANGARH: "Hanumangarh",
      GANGANAGAR: "Sri Ganganagar",
    },
    JAIPUR: {
      JAIPUR: "Jaipur",
      DAUSA: "Dausa",
      SIKAR: "Sikar",
      ALWAR: "Alwar",
      JHUNJHUNU: "Jhunjhunu",
    },
    JODHPUR: {
      JODHPUR: "Jodhpur",
      BARMER: "Barmer",
      JALORE: "Jalore",
      PALI: "Pali",
      SIROHI: "Sirohi",
    },
    KOTA: {
      KOTA: "Kota",
      BUNDI: "Bundi",
      BARAN: "Baran",
      JHALAWAR: "Jhalawar",
    },
    UDAIPUR: {
      UDAIPUR: "Udaipur",
      BANSWARA: "Banswara",
      CHITTORGARH: "Chittorgarh",
      DUNGARPUR: "Dungarpur",
      RAJSAMAND: "Rajsamand",
      PRATAPGARH: "Pratapgarh",
    },
  },
  "Uttar Pradesh": {
    AGRA: {
      AGRA: "Agra",
      FIROZABAD: "Firozabad",
      MAINPURI: "Mainpuri",
      MATHURA: "Mathura",
    },
    ALLAHABAD: {
      PRAYAGRAJ: "Prayagraj (Allahabad)",
      FATEHPUR: "Fatehpur",
      KAUSHAMBI: "Kaushambi",
      PRATAPGARH: "Pratapgarh",
    },
    AZAMGARH: {
      AZAMGARH: "Azamgarh",
      MAU: "Mau",
      BALLIA: "Ballia",
    },
    BAREILLY: {
      BAREILLY: "Bareilly",
      BUDAUN: "Budaun",
      PILIBHIT: "Pilibhit",
      SHAHJAHANPUR: "Shahjahanpur",
    },
    CHITRAKOOT: {
      BANDA: "Banda",
      CHITRAKOOT: "Chitrakoot",
      HAMIRPUR: "Hamirpur",
      MAHOBA: "Mahoba",
    },
    FAIZABAD: {
      AYODHYA: "Ayodhya (Faizabad)",
      AMBEDKAR_NAGAR: "Ambedkar Nagar",
      BARABANKI: "Barabanki",
      SULTANPUR: "Sultanpur",
      AMETHI: "Amethi",
    },
    GORAKHPUR: {
      GORAKHPUR: "Gorakhpur",
      DEORIA: "Deoria",
      KUSHINAGAR: "Kushinagar",
      MAHARAJGANJ: "Maharajganj",
    },
    JHANSI: {
      JHANSI: "Jhansi",
      LALITPUR: "Lalitpur",
      JALAUN: "Jalaun",
    },
    KANPUR: {
      KANPUR_NAGAR: "Kanpur Nagar",
      KANPUR_DEHAT: "Kanpur Dehat",
      AURAIYA: "Auraiya",
      FARRUKHABAD: "Farrukhabad",
    },
    LUCKNOW: {
      LUCKNOW: "Lucknow",
      HARDOI: "Hardoi",
      LAKHIMPUR_KHERI: "Lakhimpur Kheri",
      RAE_BARELI: "Rae Bareli",
      SITAPUR: "Sitapur",
      UNNAO: "Unnao",
    },
    MEERUT: {
      MEERUT: "Meerut",
      BAGHPAT: "Baghpat",
      GHAZIABAD: "Ghaziabad",
      HAPUR: "Hapur",
      GAUTAM_BUDDHA_NAGAR: "Gautam Buddha Nagar (Noida)",
      BULANDSHAHR: "Bulandshahr",
    },
    MIRZAPUR: {
      MIRZAPUR: "Mirzapur",
      SONBHADRA: "Sonbhadra",
      BHADOHI: "Bhadohi (Sant Ravidas Nagar)",
    },
    MORADABAD: {
      MORADABAD: "Moradabad",
      AMROHA: "Amroha (J.P. Nagar)",
      BIJNOR: "Bijnor",
      RAMPUR: "Rampur",
      SAMBHAL: "Sambhal",
    },
    SAHARANPUR: {
      SAHARANPUR: "Saharanpur",
      SHAMLI: "Shamli",
      MUZAFFARNAGAR: "Muzaffarnagar",
    },
    VARANASI: {
      VARANASI: "Varanasi",
      CHANDAULI: "Chandauli",
      GHAZIPUR: "Ghazipur",
      JAUNPUR: "Jaunpur",
    },
  },
};
